import {
  AllocateSegmentMutation,
  Exact,
  SegmentFragment,
  useAllocateSegmentMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useAllocateSegment = withStandardMutationHook<
  AllocateSegmentMutation,
  SegmentFragment,
  Exact<{ name: string }>,
  'allocateSegment',
  [string]
>(useAllocateSegmentMutation, 'allocateSegment', (name: string) => ({
  name,
}));
